import Suru from "../../../../suru/js/app";

$(document).ready(function(){
   Suru.navbutton();
   var emailArticle = $("#emailArticle");
   if(emailArticle.length > 0)
   {
   		var href = emailArticle.attr("href") + window.location.href;
   		emailArticle.attr("href", href);	    	
   }
});
